import Vue from 'vue'
const storageName = 'activity'

function getInitData (app) {
  return Promise.resolve()
}

const getUrlCode = function (code) {
  const search = window.location.search.substr(1)
  const rag = RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
  const result = search.match(rag)
  return result ? result[2] : null
}

// 打开应用获取登录和退出状态
Vue.prototype.$isLoggedIn = async function () {
  const token = localStorage.getItem('token')
  const urlToken = getUrlCode('token')
  if (urlToken && !token) {
    localStorage.setItem('token', urlToken)
  }
  if (token || urlToken) {
    return token || urlToken
  } else {
    // eslint-disable-next-line no-throw-literal
    throw {}
  }
}

// 登录操作
Vue.prototype.$login = async function (data) {
  return this.$service.login(data).then(res => {
    let user = {
      name: '',
      token: res.token
    }
    this.$service.service.state = user
    this.$appState.$storage(storageName).$set('user', user)
    return user
  })
}

// 退出操作
Vue.prototype.$logout = async function () {
  this.$appState.user = undefined
  this.$appState.$storage(storageName).$remove('user')
}
